<div class="container-fluid result-header-grid">

    <div class="py-2">
        <tf-sort-by
            sortBy="assayId"
            [currentSortBy]="currentSortBy"
            [direction]="currentSortDirection"
            (onSort)="onSort($event)">
            Assay ID
        </tf-sort-by>
    </div>

    <div class="py-2">
        <tf-sort-by
            sortBy="gene"
            [currentSortBy]="currentSortBy"
            [direction]="currentSortDirection"
            (onSort)="onSort($event)">
            Gene
        </tf-sort-by>
    </div>

    <div class="tf-font-medium py-2">
        Species
    </div>

    <div class="py-2">
        <tf-sort-by
            sortBy="transcripts"
            [currentSortBy]="currentSortBy"
            [direction]="currentSortDirection"
            (onSort)="onSort($event)">
            Transcripts
        </tf-sort-by>
    </div>

    <div class="py-2">
        <tf-sort-by
            sortBy="ampliconLength"
            [currentSortBy]="currentSortBy"
            [direction]="currentSortDirection"
            (onSort)="onSort($event)">
            Amplicon
        </tf-sort-by>
    </div>

    <div class="tf-font-medium py-2">
        Dye / Size
    </div>

    <div class="tf-font-medium py-2">
        <tf-price-header></tf-price-header>
    </div>

    <div>
    </div>

    <div class="d-flex justify-content-end py-2 search-results-row-checkbox">
        <tf-checkbox
            (onClick)="handleCheckChange($event)"
            [(ngModel)]="checked"
            [partial]="isPartial">
        </tf-checkbox>
    </div>

</div>
